/** Human-readable labels for clubs.verification_status (DB values). */
export const CLUB_VERIFICATION_LABELS: Record<string, string> = {
  draft: 'Draft',
  pending_review: 'Pending review',
  unverified: 'Listed',
  verified: 'Published',
  partner: 'Partner',
  suspended: 'Suspended',
  archived: 'Archived',
};

export function clubVerificationLabel(status: string | null | undefined): string {
  if (!status) return 'Unknown';
  return CLUB_VERIFICATION_LABELS[status] ?? status.replace(/_/g, ' ');
}

/** Clubs visible on /clubs and public profiles. */
export function clubIsPubliclyListed(status: string | null | undefined): boolean {
  return status === 'unverified' || status === 'verified' || status === 'partner';
}

export function clubShowsVerifiedBadge(status: string | null | undefined): boolean {
  return status === 'verified' || status === 'partner';
}
